import BaseApi from "../api/BaseApi";
import {List, SimpleCell} from "@vkontakte/vkui";
import React from "react";
import BaseComponent from "../components/BaseComponent";


class SummaryList extends BaseComponent {

    constructor(props) {
        super(props);
    }
    render() {

        return (<List>
            {Object.keys(this.props.list).map((key) => (
                <SimpleCell multiline after={this.props.list[key].qnt}>
                    {this.props.list[key].name}
                </SimpleCell>
            ))}
        </List>)
    }

}

export default SummaryList